import { format, isThisYear, isToday } from 'date-fns';
import gettext from '@sdk/lang/gettext';

export const getRelativeFormattedDate = (date: Date, usTimeFormat = true) => {
  if (isToday(date)) return gettext('Today');

  if (isThisYear(date)) {
    const pattern = usTimeFormat ? 'MMM d' : 'd MMM';
    return format(date, pattern);
  }

  const pattern = usTimeFormat ? 'MMM d, y' : 'd MMM y';
  return format(date, pattern);
};
